var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExpandMenu = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.43786 5C2.09161 5 1.81287 5.275 1.81287 5.62499V6.51247C1.81287 6.86247 2.09161 7.13746 2.43786 7.13746H12.9727C13.3177 7.13746 13.5977 6.86247 13.5977 6.51247V5.62499C13.5977 5.275 13.3177 5 12.9727 5H2.43786Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.43853 11.4247C2.09228 11.4247 1.81354 11.7122 1.81354 12.0497V12.9497C1.81354 13.2872 2.09228 13.5747 2.43853 13.5747H20.1782L17.882 15.8622C17.6383 16.1121 17.6383 16.5121 17.882 16.7496L18.5132 17.3871C18.7582 17.6246 19.1532 17.6246 19.397 17.3871L23.8169 12.9622C23.9456 12.8372 24.0069 12.6622 23.9994 12.4997C24.0069 12.3247 23.9456 12.1497 23.8169 12.0247L19.397 7.6123C19.1532 7.36231 18.7582 7.36231 18.5132 7.6123L17.882 8.23729C17.6383 8.48729 17.6383 8.87478 17.882 9.12477L20.1882 11.4247H2.43853Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.81287 18.4873C1.81287 18.1373 2.09161 17.8623 2.43786 17.8623H12.9727C13.3177 17.8623 13.5977 18.1373 13.5977 18.4873V19.3748C13.5977 19.7248 13.3177 19.9998 12.9727 19.9998H2.43786C2.09161 19.9998 1.81287 19.7248 1.81287 19.3748V18.4873Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExpandMenu);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/expand_menu.5068907976dee17c5de0de9ee0a31274.svg";